// Query Keys Factory Pattern
export const queryKeys = {
  // Auth
  auth: {
    all: ['auth'] as const,
    currentUser: () => [...queryKeys.auth.all, 'currentUser'] as const,
  },

  // Public
  public: {
    all: ['public'] as const,
    projects: (params?: unknown) =>
      [...queryKeys.public.all, 'projects', params] as const,
    project: (id: number) =>
      [...queryKeys.public.all, 'project', id] as const,
    company: () => [...queryKeys.public.all, 'company'] as const,
    specializations: () => [...queryKeys.public.all, 'specializations'] as const,
    content: {
      all: ['public', 'content'] as const,
      homepage: () => ['public', 'content', 'homepage'] as const,
      about: () => ['public', 'content', 'about'] as const,
      howItWorks: () => ['public', 'content', 'how-it-works'] as const,
      faqs: () => ['public', 'content', 'faqs'] as const,
      contact: () => ['public', 'content', 'contact'] as const,
      navigation: () => ['public', 'content', 'navigation'] as const,
      footer: () => ['public', 'content', 'footer'] as const,
    },
  },

  // Client Profile
  profile: {
    all: ['profile'] as const,
    current: () => [...queryKeys.profile.all, 'current'] as const,
  },

  // Client Tenders
  tenders: {
    all: ['tenders'] as const,
    lists: () => [...queryKeys.tenders.all, 'list'] as const,
    list: (filters?: unknown) =>
      [...queryKeys.tenders.lists(), filters] as const,
    details: () => [...queryKeys.tenders.all, 'detail'] as const,
    detail: (id: number) => [...queryKeys.tenders.details(), id] as const,
  },

  // Client Offers
  offers: {
    all: ['offers'] as const,
    lists: () => [...queryKeys.offers.all, 'list'] as const,
    list: (filters?: unknown) =>
      [...queryKeys.offers.lists(), filters] as const,
    details: () => [...queryKeys.offers.all, 'detail'] as const,
    detail: (id: number) => [...queryKeys.offers.details(), id] as const,
  },

  // Client Projects
  projects: {
    all: ['projects'] as const,
    lists: () => [...queryKeys.projects.all, 'list'] as const,
    list: (filters?: unknown) =>
      [...queryKeys.projects.lists(), filters] as const,
    details: () => [...queryKeys.projects.all, 'detail'] as const,
    detail: (id: number) => [...queryKeys.projects.details(), id] as const,
  },

  // Dashboard
  dashboard: {
    all: ['dashboard'] as const,
    client: () => [...queryKeys.dashboard.all, 'client'] as const,
    admin: () => [...queryKeys.dashboard.all, 'admin'] as const,
  },

  // Admin Clients
  adminClients: {
    all: ['admin', 'clients'] as const,
    lists: () => [...queryKeys.adminClients.all, 'list'] as const,
    list: (filters?: unknown) =>
      [...queryKeys.adminClients.lists(), filters] as const,
    details: () => [...queryKeys.adminClients.all, 'detail'] as const,
    detail: (id: number) => [...queryKeys.adminClients.details(), id] as const,
  },

  // Admin Offers
  adminOffers: {
    all: ['admin', 'offers'] as const,
    lists: () => [...queryKeys.adminOffers.all, 'list'] as const,
    list: (filters?: unknown) =>
      [...queryKeys.adminOffers.lists(), filters] as const,
    details: () => [...queryKeys.adminOffers.all, 'detail'] as const,
    detail: (id: number) => [...queryKeys.adminOffers.details(), id] as const,
  },

  // Admin Content Management
  adminContent: {
    all: ['admin', 'content'] as const,
    homepage: () => [...queryKeys.adminContent.all, 'homepage'] as const,
    homepageFeatures: () => [...queryKeys.adminContent.all, 'homepage', 'features'] as const,
    homepageStatistics: () => [...queryKeys.adminContent.all, 'homepage', 'statistics'] as const,
    about: () => [...queryKeys.adminContent.all, 'about'] as const,
    aboutValues: () => [...queryKeys.adminContent.all, 'about', 'values'] as const,
    howItWorks: () => [...queryKeys.adminContent.all, 'how-it-works'] as const,
    howItWorksSteps: () => [...queryKeys.adminContent.all, 'how-it-works', 'steps'] as const,
    faqs: () => [...queryKeys.adminContent.all, 'faqs'] as const,
    contact: () => [...queryKeys.adminContent.all, 'contact'] as const,
    navigation: () => [...queryKeys.adminContent.all, 'navigation'] as const,
    footer: () => [...queryKeys.adminContent.all, 'footer'] as const,
  },

  // Company Projects (Portfolio)
  companyProjects: {
    all: ['companyProjects'] as const,
    lists: () => [...queryKeys.companyProjects.all, 'list'] as const,
    list: (filters?: unknown) =>
      [...queryKeys.companyProjects.lists(), filters] as const,
    details: () => [...queryKeys.companyProjects.all, 'detail'] as const,
    detail: (id: number) => [...queryKeys.companyProjects.details(), id] as const,
  },

  // Admin Client Projects Management
  adminProjects: {
    all: ['admin', 'projects'] as const,
    lists: () => [...queryKeys.adminProjects.all, 'list'] as const,
    list: (filters?: unknown) =>
      [...queryKeys.adminProjects.lists(), filters] as const,
    details: () => [...queryKeys.adminProjects.all, 'detail'] as const,
    detail: (id: number) => [...queryKeys.adminProjects.details(), id] as const,
  },
};
